import messages from 'locales/messages/hu';

interface LanguageConfig {
    locale: string;
    messages: Record<string, string>;
};
  
const enConfig: LanguageConfig = {
    locale: 'hu',
    messages
};
  
export default enConfig;